import React, { useState, useEffect } from "react";
import "./style.scss";
import { useStore } from "../../../../stores";

const Meetings = ({ Brief, Professionals, SelectedProf, AllUsers }) => {
  const { uiStore } = useStore();
  const [TheProf, setTheProf] = useState({});


  useEffect(() => {
    try {
      setTheProf(SelectedProf??{});
    } catch (err) {
      uiStore.showNotification(
        `Error processing selected professional: "${err}"`,
        "warning"
      );
      setTheProf({});
    }
  }, [SelectedProf]);

  const calculateDurationInHours = (startDate, endDate) => {
    try {
      if (!startDate || !endDate) return 0;
      const start = new Date(startDate);
      const end = new Date(endDate);
      return Math.abs(end - start) / (1000 * 60 * 60) || 0;
    } catch (err) {
      uiStore.showNotification(
        `Error calculating duration: "${err}"`,
        "warning"
      );
      return 0;
    }
  };

  const formatDate = (inputDate) => {
    try {
      if (!inputDate) return "00/00/0000";
      const date = new Date(inputDate);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    } catch (err) {
      uiStore.showNotification(
        `Error formatting date: "${err}"`,
        "warning"
      );
      return "00/00/0000";
    }
  };

  const extractTime = (dateString) => {
    try {
      if (!dateString) return "00:00";
      const date = new Date(dateString);
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      return `${hours}:${minutes}`;
    } catch (err) {
      uiStore.showNotification(
        `Error extracting time: "${err}"`,
        "warning"
      );
      return "00:00";
    }
  };

  const formatMessageDate = (dateString) => {
    try {
      if (!dateString) return "";
      const date = new Date(dateString);
      const now = new Date();
      const diffTime = Math.abs(now - date);
      const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

      if (date.toDateString() === now.toDateString()) return "Today";

      const yesterday = new Date(now);
      yesterday.setDate(yesterday.getDate() - 1);
      if (date.toDateString() === yesterday.toDateString()) return "Yesterday";

      if (diffDays < 7) {
        const days = [
          "Sunday",
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
        ];
        return days[date.getDay()];
      }

      const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      return `${date.getDate()} ${months[date.getMonth()]} ${date.getFullYear()}`;
    } catch (err) {
      uiStore.showNotification(
        `Error formatting message date: "${err}"`,
        "warning"
      );
      return "";
    }
  };

  const sortByTime = (array, dateField = "startDate") => {
    try {
      return [...array].sort((a, b) => {
        const timeA = extractTime(a[dateField]);
        const timeB = extractTime(b[dateField]);
        return timeA.localeCompare(timeB);
      });
    } catch (err) {
      uiStore.showNotification(`Error sorting by time: "${err}"`, "warning");
      return array || [];
    }
  };


  return (
    <div className="meeting-container">
      <p className="header">Professional Details</p>
      <div className="meeting-content">
        {/* Meeting Notes */}
        {Array.isArray(Brief?.brief?.scheduledCallNotes) &&
          Brief?.brief?.scheduledCallNotes.length > 0 && (
            <div className="meeting-notes_name">
              <p className="innerheader">Notes</p>
              <div className="notes-div">
                <p className="p-name-header">
                  {formatMessageDate(
                    Brief?.brief?.scheduledCallNotes[
                      Brief?.brief?.scheduledCallNotes.length - 1
                    ]?.date
                  )}
                </p>
                <div className="notes-body">
                  {Brief?.brief?.scheduledCallNotes.map((item) => {
                        return (
                          <div  className="name-div-item-top"  style={{    marginTop: "2%",    minHeight: "10%",    height: "auto",  }}>
                            <p className="p-name">{`${item.from.firstName} ${item.from.lastName}`}</p>
                            <p className="p-email" style={{ margin: "2% 0px", display: "flex", justifyContent: "space-between", }}>
                              <span style={{ maxWidth: "86%" }}>
                                {item.notes}
                              </span>
                              <span style={{ minHeight: "100%", color: "var(--purple)", fontSize: "10px", display: "flex", flexDirection: "column", justifyContent: "flex-end", }}>
                                {extractTime(item.date)}
                              </span>
                            </p>
                          </div>
                        );
                  })}
                </div>
              </div>
            </div>
          )}

        {/* Professional Details */}
        {Object.keys(TheProf).length > 0 && TheProf.id !== "" ? (
          <div className="meeting-notes_name">
            <div className="name-div">
              <div className="name-div-item-top">
                <p className="p-name">Name</p>
                <p className="p-email">{`${TheProf?.fullName ?? ""} `}</p>
              </div>
              <div className="name-div-item-top">
                <p className="p-name">Email Address</p>
                <p className="p-email">{TheProf.email ?? ""}</p>
              </div>
              <div className="name-div-item-bottom">
                <p className="innerheader">Availability</p>
                <div className="name-div-item-bottom-content">
                  {Array.isArray(Brief?.brief?.projectPlan) &&
                    Brief?.brief?.projectPlan.length > 0 ? Object.keys(Brief?.brief?.projectPlan[0]).includes("workHours") &&
                      Array.isArray(Brief?.brief?.projectPlan[0].workHours) &&
                      Brief?.brief?.projectPlan[0].workHours.map((xItem, index) => {
                        return (
                          <p className="avaliability">
                            <span>{xItem.day}</span>
                            <span>
                              {xItem.timeFrom}- {xItem.timeTo}
                            </span>
                          </p>
                        );
                      })
                    : null}
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="meeting-notes_name">
            <p style={{ textAlign: "center", color: "var(--red-orange)" }}>
              No Professional Selected
            </p>
          </div>
        )}

        {/* Meeting Schedule */}
        {Array.isArray(Brief?.brief?.scheduledCalls) &&
          Brief?.brief?.scheduledCalls.length > 0 ? (
          <div className="meeting-schedule">
            <p className="innerheader">Meeting Schedule</p>
            <div className="meeting-schedule-content">
              <div className="meeting-schedule-table-header">
                <p style={{ width: "30%", paddingLeft: "1%" }}>Meetings</p>
                <p style={{ width: "20%" }}>Date</p>
                <p style={{ width: "10%" }}>Time</p>
                <p style={{ width: "20%" }}>Duration</p>
                <p style={{ width: "20%" }}>Status</p>
              </div>

              <div className="meeting-schedule-table-content">
                {sortByTime(Brief?.brief?.scheduledCalls).map((meeting, index) => {
                  if (Object.keys(TheProf).includes("id")) {
                    if (TheProf.id === meeting?.professional?._id) {
                      return (
                        <div className="meeting-schedule-table-content-item">
                          <p style={{   width: "30%",   peddingLeft: "1%",   overflow: "hidden", }} >  Meeting {index + 1} </p>
                          <p style={{ width: "20%" }}>
                            {formatDate(meeting?.startDate)}
                          </p>
                          <p style={{ width: "10%" }}>
                            {extractTime(meeting?.startDate)}
                          </p>
                          <p style={{ width: "20%" }}>
                            {calculateDurationInHours(
                              meeting.startDate,
                              meeting.endDate
                            )}{" "}
                            Hours
                          </p>
                          <p style={{   width: "20%",   color:     String(meeting.status) ===     "PROFESSIONAL_DECLINED"       ? "#F26640"       : "",  }} >
                            {meeting.status === "PROFESSIONAL_DECLINED"
                              ? "DECLINED"
                              : meeting.status === "PROFESSIONAL_ACCEPTED"
                              ? "ACCEPTED"
                              : meeting.status}
                          </p>
                        </div>
                      );
                    }
                  }
                })}
              </div>
            </div>
          </div>
        ) : (
          <div className="meeting-schedule">
            <p style={{ textAlign: "center", color: "var(--red-orange)" }}>
              No meetings scheduled
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Meetings;
